<template>
  <v-fade-transition mode="out-in">
      <router-view />
  </v-fade-transition>
</template>

<script>

export default {
  // Main bootstraping component
  name: "AppWrapper",
};
</script>

<style lang="stylus" src="@/stylus/main.styl"></style>
<style lang="styluss" src="@/stylus/mobile.styl"></style>